import * as Sentry from "@sentry/react"
import type { UserPayload } from "@/shared/types"

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "dev",
    release: import.meta.env.VITE_APP_VERSION || "webfrateca@1.0.0",
    sendDefaultPii: false,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  })
}

export const setSentryUser = (user: UserPayload | null) => {
  if (!user || !user.id) {
    Sentry.setUser(null)
    return
  }
  Sentry.setUser({
    id: user.id,
    email: user.email ?? undefined,
    segment: user.plan,
  })
}

export const addAudioBreadcrumb = (message: string, data?: Record<string, any>) => {
  Sentry.addBreadcrumb({
    category: "audio-engine",
    message,
    data,
    level: "info",
  })
}

export const addSocketBreadcrumb = (message: string, data?: Record<string, any>) => {
  Sentry.addBreadcrumb({
    category: "process-socket",
    message,
    data,
    level: "info",
  })
}

export { Sentry }

